import { render, staticRenderFns } from "./importDialogClass.vue?vue&type=template&id=56b86485"
import script from "./importDialogClass.vue?vue&type=script&lang=js"
export * from "./importDialogClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports